import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import {
  CommonProvider,
  Utils,
  C,
  H,
  Image,
  ReportSiteIssueWrapper,
  ModalFormContainer,
} from '@kineticdata/bundle-common';
import { CoreForm } from '@kineticdata/react';

const Layout = connect(state => ({
  reportForm: H.selectReportSiteIssueForm(state),
}))(({ form, content, reportForm }) => {
  const image = form != null && Utils.getAttributeValue(form, C.ATTR_IMAGE);

  return (
    <>
      {image && (
        <div className="page-image">
          <Image src={image} alt="" />
        </div>
      )}
      <div className="page-panel pt-5">
        <div className="portal-page__wrapper">
          <ReportSiteIssueWrapper form={form} reportForm={reportForm}>
            {content}
          </ReportSiteIssueWrapper>
        </div>
      </div>
    </>
  );
});

export const SiteMaintenanceWrapper = connect(state => ({
  maintenance: Utils.getAttributeValue(
    state.app.space || {},
    C.SPACE_ATTR_SITE_MAINTENANCE,
  ),
  environment: Utils.getAttributeValue(
    state.app.space || {},
    C.SPACE_ATTR_ENVIRONMENT,
  ),
  authenticated: state.app.authenticated,
}))(props => {
  // Render form if maintenance attribute is not set
  if (!props.maintenance) {
    return props.children;
  }

  const dates = props.maintenance
    .split(',')
    .filter(Boolean)
    .map(d => d.trim());

  const startDateString = dates.length >= 2 ? dates[0] : null;
  const endDateString = dates.length >= 2 ? dates[1] : dates[0];

  const startDate = startDateString
    ? moment.tz(startDateString, 'America/Chicago')
    : null;
  const endDate = endDateString
    ? moment.tz(endDateString, 'America/Chicago')
    : null;

  if (startDate && !startDate.isValid()) {
    console.error('Invalid start date of Maintenance attribute value.');
  }
  // Render form if endDate for maintenance is invalid
  if (!endDate || !endDate.isValid()) {
    console.error('Invalid end date of Maintenance attribute value.');
    return props.children;
  }
  if (startDate && startDate.isValid() && startDate.isAfter(endDate)) {
    console.error(
      'Invalid Maintenance attribute value. Start date must be before end date.',
    );
    return props.children;
  }

  const now = moment();
  const isInMaintenance =
    endDate.isAfter(now) &&
    (!startDate || !startDate.isValid() || startDate.isBefore(now));

  return isInMaintenance ? (
    <>
      {props.environment &&
        props.environment !== 'PRD' && (
          <div className="app-environment">
            {props.environment === 'DEV'
              ? 'Development Environment'
              : props.environment === 'PPD'
                ? 'Pre-Production Environment'
                : `${props.environment} Environment`}
          </div>
        )}
      <CommonProvider>
        <ModalFormContainer />
        <div className="app-wrapper">
          <div className="app-body">
            <div className="app-main">
              <main className="package-layout">
                <div className="page-container">
                  <CoreForm
                    form={C.FORM_SLUG_SITE_MAINTENANCE}
                    kapp={C.KAPP_SLUG_ERMS}
                    review={true}
                    public={!props.authenticated}
                    layoutComponent={Layout}
                  />
                </div>
              </main>
            </div>
          </div>
        </div>
      </CommonProvider>
    </>
  ) : (
    props.children
  );
});
